import { action, computed, observable } from 'mobx';
import { Goal } from '../entity';

export class GoalStore {
  public static deserializeFromApiResponse(res: any): Goal {
    const id = res.id;
    const title = res.title;
    const type = res.trigger.type;
    const isMainGoal = res.lift_report_goal_config_summary.main_goal;

    if (typeof id !== 'string') {
      throw new TypeError(`'res.id' must be a string, but '${res.id}' is given`);
    }
    return new Goal({ id, title, type, isMainGoal });
  }

  @observable public goalList: Goal[] = [];
  @observable public selectedGoalId: string = '';
  @observable public isLoading: boolean = true;

  @computed
  get selectedGoal(): Goal | null {
    return (
      this.goalList.find(item => item.id === this.selectedGoalId) || (this.goalList.length ? this.goalList[0] : null)
    );
  }

  @action
  public setGoalList(res: any[]): void {
    if (res.length > 0) {
      this.goalList = res.map(item => GoalStore.deserializeFromApiResponse(item));
    } else {
      this.goalList = [];
      this.selectedGoalId = '';
    }
  }

  @action
  public clearGoalList(): void {
    this.goalList = [];
    this.selectedGoalId = '';
  }

  @action
  public setSelectedGoalId(id?: string): void {
    if (id && this.goalList.find(item => item.id === id)) {
      this.selectedGoalId = id;
    } else if (this.goalList.length > 0) {
      const mainGoals = this.goalList.filter((goal: Goal) => goal.isMainGoal);
      this.selectedGoalId = mainGoals.length > 0 ? mainGoals[0].id : this.goalList[0].id;
    }
  }

  @action
  public setLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/store/GoalStore.ts